import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { PagedListOfTheater } from '@cinemark/content-api-client';
import { clsx } from 'clsx';
import { CinemarkLink } from '../cinemark-link/cinemark-link';
import { GeoLocationComponent } from './geo-location/geo-location';
import locationStyles from './location.module.scss';
import { ZipLocationComponent } from './zip-code-location/zip-code-location';

type LocationComponentProps = {
  className?: string;
  onResults?: (results: PagedListOfTheater) => void;
  showBrowseByState?: boolean;
  title?: string;
  type?: 'page' | 'dialog';
};

export const LocationComponent = ({ className, onResults, showBrowseByState = false, title, type = 'page' }: LocationComponentProps): React.JSX.Element => {
  return (
    <div className={clsx('flex flex-col', type === 'dialog' ? 'gap-ms' : 'gap-md', className)}>
      {title &&
        <h2 className="self-center"
          data-test="location-title"
        >
          {title}
        </h2>
      }

      <div className={clsx(locationStyles.location, type === 'page' && locationStyles.page)}>
        <GeoLocationComponent onResults={onResults} />
        <ZipLocationComponent type="full"
          onResults={onResults}
        />
      </div>

      {showBrowseByState &&
        <div className="flex flex-col gap-sm w-full text-center">
          <p data-test="location-or-text">OR</p>

          <CinemarkLink useAnchor
            className="text-primary font-bold"
            dataLinkCategory={AnalyticsPageCategories.THEATERS}
            dataLinkName="Browse Theatres By State"
            dataTest={`link-browse-theaters-by-state`}
            href="/full-theatre-list"
          >
            Browse Theatres By State
          </CinemarkLink>
        </div>
      }
    </div>
  );
};
